import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Navbar from './component/Navbar';

const HelloKejati = () => {
    const url = window.location.origin;
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;

    const [loading, setLoading] = useState(true);
    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const URL_GET_PROJECT = `${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`;

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response;
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(URL_GET_PROJECT).then((value) => {
            setAppLogo(`${process.env.REACT_APP_API_URL}upload/logo/${value.data.logo}`)
        });

    }, [domain]);

    if (loading) {
        return <div>Loading...</div>;
    }

    const overlayStyle = {
        position: 'absolute',           // Absolutely position the overlay on top of the background
        top: '150px',
        left: 0,
        right: 0,
        bottom: '150px',
        backgroundImage: `url(${appLogo})`,  // Dynamically use the appLogo as the background image
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,                   // Set opacity for transparency (0 is fully transparent, 1 is opaque)
        pointerEvents: 'none',
    };

    return (
        <div >
            <div style={overlayStyle}></div>
            <Navbar appLogo={appLogo} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
        </div>
    )
}

export default HelloKejati;